var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEye2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 2 12 8",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6A1.5 1.5 0 0 1 6 7.5 1.5 1.5 0 0 1 4.5 6a1.5 1.5 0 0 1 3 0z",
    fill: "#337aff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C4 2 2 3 0 6c2 3 4 4 6 4s4-1 6-4c-2-3-4-4-6-4zm0 6.5C4.622 8.5 3.5 7.379 3.5 6S4.622 3.5 6 3.5 8.5 4.621 8.5 6 7.378 8.5 6 8.5z",
    fill: "#337aff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEye2);
export default __webpack_public_path__ + "static/media/ico-eye2.4a122e3d4bbd6aee7291c097412c3066.svg";
export { ForwardRef as ReactComponent };